"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Format = void 0;
var Format = (function () {
    function Format() {
    }
    Format.email = function (value) {
        if (typeof value === 'string') {
            return value.toLowerCase();
        }
        console.warn(new TypeError("Unable to parse value as string: " + value));
        return 'ERR';
    };
    return Format;
}());
exports.Format = Format;
//# sourceMappingURL=Format.js.map